import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual-lottery',
  templateUrl: './manual-lottery.component.html',
  styleUrls: ['./manual-lottery.component.css']
})
export class ManualLotteryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/manual-lottery/manual-lottery.component.ts